import * as z from "zod";

export const AI_MODEL_COMPARISON_MODELS = [
  { id: "gpt-5.2", label: "GPT-5.2" },
  { id: "gpt-5.6-sol", label: "Sol" },
  { id: "gpt-5.6-luna", label: "Luna" },
] as const;

export const aiModelComparisonModelSchema = z.enum(
  AI_MODEL_COMPARISON_MODELS.map(({ id }) => id) as [string, ...string[]],
);

export const aiModelComparisonListInputSchema = z.object({
  organizationId: z.string().min(1),
});

export const aiModelComparisonItemsInputSchema = z.object({
  surveyId: z.string().min(1),
});

export const aiModelComparisonInputSchema = z.object({
  surveyId: z.string().min(1),
  itemId: z.string().min(1),
});

const usageSchema = z.object({
  inputTokens: z.number().int().nonnegative().nullable(),
  outputTokens: z.number().int().nonnegative().nullable(),
  totalTokens: z.number().int().nonnegative().nullable(),
});

const resultSchema = z.object({
  modelId: aiModelComparisonModelSchema,
  paragraph: z.string().nullable(),
  generationTimeMs: z.number().int().nonnegative().nullable(),
  usage: usageSchema.nullable(),
  error: z.string().nullable(),
});

export const aiModelComparisonResponseSchema = z.object({
  surveyId: z.string(),
  itemId: z.string(),
  itemTitle: z.string(),
  models: z.array(
    z.object({
      id: aiModelComparisonModelSchema,
      label: z.string(),
    }),
  ),
  generationMode: z.enum(["ai", "deterministic", "empty"]),
  deterministicOutput: z.string().nullable(),
  results: z.array(resultSchema),
});

export const aiModelComparisonSurveysResponseSchema = z.object({
  data: z.array(
    z.object({
      id: z.string(),
      vesselName: z.string().nullable(),
      clientName: z.string().nullable(),
      surveyDate: z.coerce.date().nullable(),
      createdAt: z.coerce.date(),
    }),
  ),
});

export const aiModelComparisonItemsResponseSchema = z.object({
  data: z.array(
    z.object({
      id: z.string(),
      title: z.string(),
      areaName: z.string(),
    }),
  ),
});

export type AIModelComparisonResponse = z.infer<
  typeof aiModelComparisonResponseSchema
>;
